/**
 * 包含里程碑动画和线性动画的实现
 */

(function() {
    'use strict';

    // ==================== 工具函数 ====================
    
    // 设备检测
    const isPc = () => window.innerWidth >= 1024;
    const isXl = () => window.innerWidth >= 1280;
    const isPad = () => window.innerWidth >= 650 && window.innerWidth < 1024;
    const isMo = () => window.innerWidth < 650;
    
    // 像素转换函数
    const px = (value) => {
        const ratio = isPc() ? 1 : isPad() ? 0.7111 : 1;
        return value * ratio;
    };
    
    const rpx = (value) => px(value);
    const vw = (value) => window.innerWidth * value / 100;
    const vh = (value) => window.innerHeight * value / 100;
    const t0 = (value) => value; // 简化版本
    
    // DOM 查询函数
    const query = (selector, parent = document) => parent.querySelector(selector);
    const queryAll = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));
    
    // 元素扩展方法
    Element.prototype.query = function(selector) { return this.querySelector(selector); };
    Element.prototype.queryAll = function(selector) { return Array.from(this.querySelectorAll(selector)); };
    Element.prototype._width = function() { return this.offsetWidth; };
    Element.prototype._height = function() { return this.offsetHeight; };
    Element.prototype._top = function() { return this.offsetTop; };
    Element.prototype._bottom = function() { return this.offsetTop + this.offsetHeight; };
    
    // 类操作函数
    const addClass = (el, className) => el.classList.add(className);
    const removeClass = (el, className) => el.classList.remove(className);
    const hasClass = (el, className) => el.classList.contains(className);
    
    // 动画工具函数 - 模拟 Ui.default.timeline
    const createTimeline = (options) => {
        const defaultOptions = {
            autoplay: false,
            duration: 1000,
            easing: 'linear'
        };
        
        const config = { ...defaultOptions, ...options };
        let currentTime = 0;
        let isPlaying = false;
        let isPaused = false;
        let animationId = null;
        const animations = [];
        let updateCallback = null;
        
        const timeline = {
            duration: config.duration,
            add: (animation, offset) => {
                // 处理偏移参数
                if (offset && typeof offset === 'string' && offset.startsWith('-=')) {
                    const offsetValue = parseInt(offset.substring(2));
                    animation.startTime = config.duration - offsetValue;
                } else if (offset && typeof offset === 'number') {
                    // 处理数字偏移量
                    animation.startTime = offset;
                }
                // 处理 offset 属性
                if (animation.offset) {
                    animation.startTime = animation.offset;
                }
                animations.push(animation);
                return timeline;
            },
            seek: (time) => {
                currentTime = Math.max(0, Math.min(time, config.duration));
                const progress = currentTime / config.duration;
                
                // 调用 update 回调
                if (updateCallback) {
                    updateCallback({
                        progress: progress * 100,
                        pause: () => { isPaused = true; }
                    });
                }
                
                animations.forEach(anim => {
                    if (anim.targets) {
                        // 确保 targets 是数组
                        const targets = Array.isArray(anim.targets) ? anim.targets : [anim.targets];
                        targets.forEach(target => {
                            if (target && target.style) {
                                if(isPc()) {
                                //   console.log('-------case only PC------- 执行动画');   
                                  if (anim.translateX) {
                                    const [start, end] = typeof anim.translateX === 'function' ? anim.translateX() : anim.translateX;
                                    const currentX = start + (end - start) * progress;
                                    target.style.transform = `translateX(${currentX}px)`;
                                  }
                                  if (anim.strokeDashoffset) {
                                    const [start, end] = anim.strokeDashoffset;
                                    const currentOffset = start + (end - start) * progress;
                                    target.style.strokeDashoffset = `${currentOffset}px`;
                                  }
                                  if (anim.opacity) {
                                    const [start, end] = anim.opacity;
                                    const currentOpacity = start + (end - start) * progress;
                                    target.style.opacity = currentOpacity;
                                  }
                                } else {
                                    
                                //   console.log('-------case except PC------- 执行动画'); 
                                //   console.log('-------case except PC------- anim:', anim);
                                //   console.log('-------case except PC------- currentTime:', currentTime);
                                  
                                  // 分别处理每个动画属性，每个属性可能有不同的时间范围
                                  
                                  // 处理 translateX
                                  if (anim.translateX) {
                                      const translateStartTime = anim.startTime || 0;
                                      const translateEndTime = translateStartTime + (anim.duration || config.duration);
                                      
                                      if (currentTime >= translateStartTime && currentTime <= translateEndTime) {
                                          const translateProgress = (currentTime - translateStartTime) / (anim.duration || config.duration);
                                          const [start, end] = typeof anim.translateX === 'function' ? anim.translateX() : anim.translateX;
                                          const currentX = start + (end - start) * translateProgress;
                                        //   console.log('-------case except PC------- translateX currentX:', currentX);
                                          target.style.transform = `translateX(${currentX}px)`;
                                      } else {
                                          // 重置 translateX
                                          const [start, end] = typeof anim.translateX === 'function' ? anim.translateX() : anim.translateX;
                                          const resetX = currentTime < translateStartTime ? start : end;
                                          target.style.transform = `translateX(${resetX}px)`;
                                      }
                                  }
                                  
                                  // 处理 strokeDashoffset（从动画开始就执行）
                                  if (anim.strokeDashoffset) {
                                      const strokeStartTime = 0; // 从动画开始就执行
                                      const strokeEndTime = anim.duration || config.duration;
                                      
                                      if (currentTime >= strokeStartTime && currentTime <= strokeEndTime) {
                                          const strokeProgress = currentTime / (anim.duration || config.duration);
                                          const [start, end] = anim.strokeDashoffset;
                                          const currentOffset = start + (end - start) * strokeProgress;
                                          target.style.strokeDashoffset = `${currentOffset}px`;
                                      } else {
                                          // 重置 strokeDashoffset
                                          const [start, end] = anim.strokeDashoffset;
                                          const resetOffset = currentTime < strokeStartTime ? start : end;
                                          target.style.strokeDashoffset = `${resetOffset}px`;
                                      }
                                  }
                                  
                                  // 处理 opacity（从动画开始就执行）
                                  if (anim.opacity) {
                                      const opacityStartTime = 0; // 从动画开始就执行
                                      const opacityEndTime = anim.duration || config.duration;
                                      
                                      if (currentTime >= opacityStartTime && currentTime <= opacityEndTime) {
                                          const opacityProgress = currentTime / (anim.duration || config.duration);
                                          const [start, end] = anim.opacity;
                                          const currentOpacity = start + (end - start) * opacityProgress;
                                          target.style.opacity = currentOpacity;
                                      } else {
                                          // 重置 opacity
                                          const [start, end] = anim.opacity;
                                          const resetOpacity = currentTime < opacityStartTime ? start : end;
                                          target.style.opacity = resetOpacity;
                                      }
                                  }
                                }
                            }
                        });
                    }
                });
            },
            play: () => {
                if (isPlaying && !isPaused) return;
                
                isPlaying = true;
                isPaused = false;
                
                const startTime = Date.now() - currentTime;
                
                const animate = () => {
                    if (!isPlaying || isPaused) return;
                    
                    const elapsed = Date.now() - startTime;
                    currentTime = Math.min(elapsed, config.duration);
                    
                    timeline.seek(currentTime);
                    
                    if (currentTime < config.duration) {
                        animationId = requestAnimationFrame(animate);
                    } else {
                        isPlaying = false;
                    }
                };
                
                animationId = requestAnimationFrame(animate);
            },
            pause: () => {
                isPaused = true;
                if (animationId) {
                    cancelAnimationFrame(animationId);
                    animationId = null;
                }
            },
            update: (callback) => {
                updateCallback = callback;
                return timeline;
            }
        };
        
        return timeline;
    };

    // ==================== 滚动监听器 ====================
    
    class ScrollManager {
        constructor() {
            this.listeners = [];
            this.init();
        }
        
        init() {
            window.addEventListener('scroll', () => {
                this.update();
            });
            
            window.addEventListener('resize', () => {
                this.update();
            });
        }
        
        addScroll(options) {
            const listener = {
                ...options,
                id: Date.now() + Math.random()
            };
            
            this.listeners.push(listener);
            return listener;
        }
        
        update() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            
            this.listeners.forEach(listener => {
                let progress = 0;
                
                if (listener.start && listener.end) {
                    const start = typeof listener.start === 'function' ? listener.start() : listener.start;
                    const end = typeof listener.end === 'function' ? listener.end() : listener.end;
                    
                    if (scrollTop >= start && scrollTop <= end) {
                        progress = (scrollTop - start) / (end - start);
                    } else if (scrollTop > end) {
                        progress = 1;
                    }
                } else if (listener.element) {
                    // 基于视口位置的进度计算
                    const rect = listener.element.getBoundingClientRect();
                    const elementTop = rect.top + scrollTop;
                    const elementBottom = elementTop + rect.height;
                    const viewportTop = scrollTop;
                    const viewportBottom = scrollTop + windowHeight;
                    
                    if (elementBottom > viewportTop && elementTop < viewportBottom) {
                        progress = (viewportBottom - elementTop) / (rect.height + windowHeight);
                        progress = Math.max(0, Math.min(1, progress));
                    } else if (elementTop >= viewportBottom) {
                        progress = 0;
                    } else {
                        progress = 1;
                    }
                }
                
                if (listener.handler) {
                    listener.handler(progress);
                }
            });
        }
    }

    // ==================== 里程碑动画函数 ====================
    
    // hi 函数 - 移动端实现
    const hi = (s, e) => {
        // console.log('-------case------- hi函数被调用（移动端）');
        const r = e.query(".mo-only [data-container]");
        const a = e.query(".mo-only [milestone-inner]");
        const u = e.query(".mo-only [milestone-wrapper]");
        const c = e.query(".mo-only [milestone-data-wrapper]");
        const milestoneData = e.query(".mo-only [milestone-data]");
        // console.log('-------case------- r:', r);
        // console.log('-------case------- a:', a);
        // console.log('-------case------- u:', u);
        // console.log('-------case------- c:', c);
        // console.log('-------case------- milestoneData:', milestoneData);
        if (!r || !a || !u || !c || !milestoneData) {
            // console.log('-------case------- hi函数：缺少必要元素');
            return;
        }
        
        u.style.height = `${milestoneData._height()}px`;
        const E = Math.floor(milestoneData._height() / (1 + 6));
        const A = a.query(".dot");
        
        if (A) {
            Array.from(new Array(E)).forEach(k => {
                const j = A.cloneNode(true);
                a.appendChild(j);
            });
        }
        
        const g = e.queryAll(".mo-only .milestone-point");
        const C = e.query(".mo-only .milestone-show-more");
        const x = e.query(".mo-only .milestone-show-less");
        const T = a.queryAll(".dot");
        
        g.forEach((k, j) => {
            let N = 0;
            Array.from(new Array(j)).map((ce, be) => {
                N = N + g[be]._height();
            });
            N > 0 && (N = N + 36);
            const ne = Math.floor(N / (1 + 6));
            if (T[ne]) {
              addClass(T[ne], "active");
            }
        });
        
        if (x) x.style.display = "none";
        
        const O = 3;
        let B = O;
        let H = 0;
        
        Array.from(new Array(O)).map((k, j) => {
            H = H + g[j]._height();
        });
        
        if (r) r.style.height = `${H}px`;
        
        if (C) {
            C.addEventListener("click", () => {
                // 点击时直接展开所有项目
                B = g.length;
                C.style.display = "none";
                if (x) x.style.display = "flex";
                
                let k = 0;
                Array.from(new Array(B)).map((j, N) => {
                    k = k + g[N]._height();
                });
                if (r) r.style.height = `${k}px`;
            });
        }
        
        if (x) {
            x.addEventListener("click", () => {
                x.style.display = "none";
                if (C) C.style.display = "flex";
                B = O;
                let k = 0;
                Array.from(new Array(B)).map((j, N) => {
                    k = k + g[N]._height();
                });
                if (r) r.style.height = `${k}px`;
                window.scrollTo({
                    behavior: "instant",
                    left: 0,
                    top: e._bottom() - vh(100)
                });
            });
        }
    };
    
    // ts 函数 - 平板端和大屏PC端实现
    const ts = (s, e) => {
        // console.log('-------case------- ts函数被调用（平板端/大屏PC端）');
        let r = false;
        // 动态获取所有 stone-grid 元素
        const stoneElements = e.queryAll(".small-pc-exclude .stone-grid");
        const stoneCount = stoneElements.length;
        const baseStoneCount = s.isPad() ? 9.5 : 9.5;
        const a = Math.round((4000 / baseStoneCount) * stoneCount);
        const u = s.isPad() ? (1 - 2 / stoneCount) * a : (1- 5 / stoneCount) * a;
        // console.log('-------case------- u:', u);
        const c = e.query(".small-pc-exclude [milestone-data]");
        const E = e.queryAll(".small-pc-exclude .dot");
        const A = e.query(".small-pc-exclude .button-img");
        const p = e.query(".small-pc-exclude [x-content]"); 
        const pOffsetLeft = p.getBoundingClientRect().left;
        // console.log('-------case------- pOffsetLeft:', vw(100) - pOffsetLeft);
        const g = e.query(".small-pc-exclude [milestone-wrapper]");
        
        
        
        // 动态计算 x-content 宽度和 SVG 路径宽度
        const baseXContentWidth = 2885; // 9个stone时的宽度
        const baseSvgWidth = s.isPad() ? 3848 : 3520; // 平板端3848px，PC端3520px
        if(s.isPc()){
          const dynamicXContentWidth = Math.round((baseXContentWidth / baseStoneCount) * stoneCount);
          const xContent = e.query(".small-pc-exclude [x-content]");
            if (xContent) {
                xContent.style.width = `${dynamicXContentWidth}px`;
            }
        }
        const dynamicSvgWidth = Math.round((baseSvgWidth / baseStoneCount) * stoneCount);
        // 动态设置 x-content 元素的宽度
        
        
        // 动态设置 SVG 元素的宽度和 viewBox
        const svgElement = s.isPad() ? 
            e.query(".small-pc-exclude .pad-svg") : 
            e.query(".small-pc-exclude .pc-svg");
        if (svgElement) {
            svgElement.style.width = `${dynamicSvgWidth}px`;
            const svgHeight = s.isPad() ? 144 : 301;
            svgElement.setAttribute('viewBox', `0 0 ${dynamicSvgWidth} ${svgHeight}`);
        }
        
        const C = dynamicSvgWidth - vw(100) - vw(40);
        const x = vw(50) - (s.isXl() ? t0(600) : t0(456)) - 64 + dynamicSvgWidth - vw(100) + (vw(50) - (s.isXl() ? t0(600) : t0(456)) - 38);
        const T = s.isPad() ? C : x;
        const O = s.isPad() ? 96 : 160;
        
        // console.log('-------case------- g:', g);
        // console.log('-------case------- A:', A);
        // console.log('-------case------- p:', p);
        // console.log('-------case------- T:', T);
        // console.log('-------case------- O:', O);
        if (!g || !A || !p) {
            // console.log('-------case------- ts函数：缺少必要元素');
            return;
        }
        
        g.style.transition = "all 0.3s ease";
        
        if (s.isPad()) {
            // 平板端：激活前两个 stone 元素
            if (stoneElements[0]) addClass(stoneElements[0], "active");
            if (stoneElements[1]) addClass(stoneElements[1], "active");
        }
        
        const he = createTimeline({
            autoplay: false,
            duration: a,
            easing: "linear"
        }).update(function(De) {
            const me = De.progress / 100;
            // console.log(`当前进度: ${(De.progress)}%`);
            
            // 动态激活 stone 元素
            stoneElements.forEach((stone, index) => {
                const threshold = index / stoneCount;
                if (me >= threshold) {
                    addClass(stone, "active");
                } else {
                    removeClass(stone, "active");
                }
            });
            
            // 根据年份位置激活对应的dot
            const yearElements = e.queryAll(".small-pc-exclude .year-text");
            yearElements.forEach((yearElement) => {
                const yearContainer = yearElement.closest('[style*="left"]');
                if (yearContainer) {
                    const yearLeft = parseFloat(yearContainer.style.left) || 0;
                    const yearPosition = yearLeft / 100; // 转换为0-1的比例
                    const dotIndex = Math.floor(yearPosition * E.length);
                    if (E[dotIndex]) {
                        addClass(E[dotIndex], "active");
                    }
                }
            });
            
            // s.isPc() && me >= 0.49 && De.pause();
            // 大屏暂停的点
            const pauseThreshold = (5 / stoneCount - 0.01);
            if(s.isPc() && me >= pauseThreshold) {
              De.pause();
            }
        });
        
        he.add({
            targets: A,
            duration: a,
            translateX: () => [0, g._width()]
        });
        
        let svgPath;
        if(s.isPad()){
          svgPath = e.query(".small-pc-exclude .pad-only .svg-path");
        } else {
          svgPath = e.query(".small-pc-exclude .pc-only .svg-path");
        }
        if (svgPath) {
            // 根据动态 SVG 宽度计算路径长度
            const baseLength = s.isPc() ? 3860 : 4164;
            const baseSvgWidth = s.isPc() ? 3520 : 3848;
            const lengthRatio = baseLength / baseSvgWidth;
            const dynamicLength = Math.round(dynamicSvgWidth * lengthRatio);
            
            // 确保SVG路径有正确的初始值
            svgPath.style.strokeDasharray = `${dynamicLength}px`;
            svgPath.style.strokeDashoffset = `${dynamicLength}px`;
            
            he.add({
                targets: svgPath,
                duration: a,
                strokeDashoffset: [dynamicLength, 0]
            }, `-=${a}`);
        }
        he.add({
          targets: p,
          duration: u,
          translateX: () => [0, -T]
        }, `-=${u}`);
        
        let Pe = false;
        
        E.forEach((De, me) => {
            De.addEventListener("click", () => {
                if (s.isPc()) he.pause();
                // 根据 dot 元素数量动态计算进度
                const pe = me / E.length;
                he.seek(he.duration * pe);
            });
        });
        
        const Fe = e.query(".small-pc-exclude [milestone-inner]");
        const xe = e.query(".small-pc-exclude .button-img-inner");
        
        if (xe) xe.style.transition = "transform 0.3s ease";
        
        if (A && Fe) {
            
            A.addEventListener("mousedown", De => {
                Pe = true;
                if (s.isPc()) he.pause();
                he.seek(he.duration * (De.x - Fe.getBoundingClientRect().left) / Fe._width());
            });
            
            A.addEventListener("touchstart", De => {
                Pe = true;
                if (s.isPc()) he.pause();
                he.seek(he.duration * (De.changedTouches[0].clientX - Fe.getBoundingClientRect().left) / Fe._width());
            });
            
            // 使用 document 监听全局事件，确保拖动范围不受限制
            const mousemoveHandler = De => {
                if (Pe && (De.x >= Fe.getBoundingClientRect().left && De.x <= Fe.getBoundingClientRect().left + Fe._width())) {
                    if (s.isPc()) he.pause();
                    he.seek(he.duration * (De.x - Fe.getBoundingClientRect().left) / Fe._width());
                }
            };
            
            const touchmoveHandler = De => {
                if (!Pe) return;
                const me = De.changedTouches[0].clientX;
                if (me >= Fe.getBoundingClientRect().left && me <= Fe.getBoundingClientRect().left + Fe._width()) {
                    if (s.isPc()) he.pause();
                    he.seek(he.duration * (me - Fe.getBoundingClientRect().left) / Fe._width());
                }
            };
            
            const mouseupHandler = () => {
                Pe = false;
            };
            
            const touchendHandler = () => {
                Pe = false;
            };
            
            // 存储全局事件监听器引用
            globalEventListeners.mousemove = mousemoveHandler;
            globalEventListeners.touchmove = touchmoveHandler;
            globalEventListeners.mouseup = mouseupHandler;
            globalEventListeners.touchend = touchendHandler;
            
            document.addEventListener("mousemove", mousemoveHandler);
            document.addEventListener("touchmove", touchmoveHandler);
            window.addEventListener("mouseup", mouseupHandler);
            window.addEventListener("touchend", touchendHandler);
        }
        
        if (s.isPad()) {
            // 平板端：根据 stone 数量动态设置初始进度
            const initialProgress = stoneCount > 0 ? 2 / stoneCount : 0.2;
            he.seek(he.duration * initialProgress);
        } else {
            // 大屏PC端：设置初始状态为0，通过滚动监听器控制
            he.seek(he.duration * 0);
            
            // 修复滚动监听器逻辑，与原始mian-v2.js保持一致
            s.addScroll({
                start: () => c._top() - vh(100),
                end: () => c._bottom() - (s.plgs?.variables?.getNavHeight() || 0),
                handler(De) {
                    if (De > 0 && !r) {
                        r = true;
                        he.play();
                    }
                }
            });
        }
    };
    
    // Bs 函数 - PC端实现
    const Bs = (s, e) => {
        // console.log('-------case------- Bs函数被调用（PC端）');
        const r = e.queryAll(".small-pc-only .dot");
        const a = e.query(".small-pc-only .button-img");
        const u = e.query(".sticky-container");
        const c = e.query(".small-pc-only .sticky-placeholder");
        const E = e.query(".small-pc-only [x-content]");
        const A = e.query(".small-pc-only [milestone-wrapper]");
        const p = vh(-5);
        const baseStoneCount = 9.6;
        
        // 动态获取所有 stone-grid 元素
        const stoneElements = e.queryAll(".small-pc-only .stone-grid");
        const stoneCount = stoneElements.length;
        
        // 动态计算 x-content 宽度和 SVG 路径宽度
        const baseXContentWidth = 2885; // 9个stone时的宽度
        const baseSvgWidth = 3520; // PC端3520px
        const dynamicXContentWidth = Math.round((baseXContentWidth / baseStoneCount) * stoneCount);
        const dynamicSvgWidth = Math.round((baseSvgWidth / baseStoneCount) * stoneCount);
        
        // 动态设置 x-content 元素的宽度
        if (E) {
            E.style.width = `${dynamicXContentWidth}px`;
        }
        
        // 动态设置 SVG 元素的宽度和 viewBox
        const svgElement = e.query(".small-pc-only .pc-svg");
        if (svgElement) {
            svgElement.style.width = `${dynamicSvgWidth}px`;
            const svgHeight = 301;
            svgElement.setAttribute('viewBox', `0 0 ${dynamicSvgWidth} ${svgHeight}`);
        }
        
        // 动态计算 g 值
        const g = vw(50) - (s.isXl() ? t0(600) : t0(456)) - 64 + dynamicSvgWidth - vw(100) + (vw(50) - (s.isXl() ? t0(600) : t0(456)) - 38);
        
        if (!c || !A || !E || !a) {
            // console.log('-------case------- Bs函数：缺少必要元素');
            return;
        }
        
        c.style.marginTop = `${g + p}px`;
        
        const C = createTimeline({
            autoplay: false,
            easing: "linear"
        });
        
        C.add({
            targets: a,
            duration: 10,
            translateX: () => [0, A._width()]
        });
        
        C.add({
            targets: E,
            duration: 10,
            offset: -9,
            translateX: () => [0, -g]
        });
        
        const x = createTimeline({
            autoplay: false,
            easing: "linear"
        });
        
        const svgPath = e.query(".small-pc-only .svg-path");
        if (svgPath) {
            // 根据动态 SVG 宽度计算路径长度
            const baseLength = s.isPc() ? 3860 : 4164;
            const baseSvgWidth = s.isPc() ? 3520 : 3848;
            const lengthRatio = baseLength / baseSvgWidth;
            const dynamicLength = Math.round(dynamicSvgWidth * lengthRatio);
            
            // 确保SVG路径有正确的初始值
            svgPath.style.strokeDasharray = `${dynamicLength}px`;
            svgPath.style.strokeDashoffset = `${dynamicLength}px`;
            
            x.add({
                targets: svgPath,
                duration: 1,
                strokeDashoffset: [dynamicLength, 0]
            });
        }
        
        if (u) {
            A.style.transition = "all 0.3s ease";
            s.addScroll({
                start: () => u._top() - (s.plgs?.variables?.getNavHeight() || 0) - vh(20),
                end: () => u._bottom() - vh(100),
                handler(he) {
                    // 动态激活 stone 元素
                    stoneElements.forEach((stone, index) => {
                        const threshold = index / stoneCount;
                        if (he >= threshold) {
                            addClass(stone, "active");
                        } else {
                            removeClass(stone, "active");
                        }
                    });
                    
                    // 根据年份位置激活对应的dot
                    const yearElements = e.queryAll(".small-pc-only .year-text");
                    yearElements.forEach((yearElement) => {
                        const yearContainer = yearElement.closest('[style*="left"]');
                        if (yearContainer) {
                            const yearLeft = parseFloat(yearContainer.style.left) || 0;
                            const yearPosition = yearLeft / 100; // 转换为0-1的比例
                            
                            const dotIndex = Math.floor(yearPosition * r.length);
                            if (r[dotIndex]) {
                                addClass(r[dotIndex], "active");
                            }
                        }
                    });
                }
            });
            
            s.addScroll({
                start: () => u._top() - (s.plgs?.variables?.getNavHeight() || 0) + p,
                end: () => u._bottom() - vh(100),
                handler(he) {
                    C.seek(C.duration * he);
                    x.seek(x.duration * he);
                    if (he === 0) {
                        A.style.visibility = "hidden";
                        A.style.opacity = "0";
                    } else {
                        A.style.visibility = "visible";
                        A.style.opacity = "1";
                    }
                }
            });
            
            s.addScroll({
                start: () => u._top() - (s.plgs?.variables?.getNavHeight() || 0),
                end: () => u._bottom() - vh(100),
                handler(he) {
                    if (he === 0) {
                        A.style.visibility = "hidden";
                        A.style.opacity = "0";
                    } else {
                        A.style.visibility = "visible";
                        A.style.opacity = "1";
                    }
                }
            });
            
            // 移除初始状态设置，与 mian-v2.js 保持一致
            // 初始状态应该通过滚动监听器自然控制
        }
        
        r.forEach((he, Pe) => {
            he.addEventListener("click", () => {
                // console.log('-------case------- dot点击事件触发');
                if (u) {
                    // 根据 dot 元素数量动态计算进度
                    const pe = Pe / r.length;
                    window.scrollTo({
                        behavior: "smooth",
                        left: 0,
                        top: u._top() - (s.plgs?.variables?.getNavHeight() || 0) + p + g * pe
                    });
                }
            });
        });
        
        const ce = e.query(".small-pc-only [milestone-inner]");
        const be = e.query(".small-pc-only .button-img-inner");
        
        if (be) be.style.transition = "transform 0.3s ease";
        
        // 模拟 Nr() 函数，总是返回 false
        const Nr = () => false;
        
        if (a && ce && u && !Nr()) {
            let he = false;
            
            // console.log('-------case------- 绑定按钮拖动事件（Bs函数）');
            
            a.addEventListener("mousedown", Pe => {
                // console.log('-------case------- 按钮 mousedown 事件触发（Bs函数）');
                he = true;
                const progress = (Pe.x - ce.getBoundingClientRect().left) / ce._width();
                window.scrollTo({
                    behavior: "smooth",
                    left: 0,
                    top: u._top() - (s.plgs?.variables?.getNavHeight() || 0) + p + g * progress
                });
            });
            
            a.addEventListener("touchstart", Pe => {
                // console.log('-------case------- 按钮 touchstart 事件触发（Bs函数）');
                he = true;
                const progress = (Pe.changedTouches[0].clientX - ce.getBoundingClientRect().left) / ce._width();
                window.scrollTo({
                    behavior: "smooth",
                    left: 0,
                    top: u._top() - (s.plgs?.variables?.getNavHeight() || 0) + p + g * progress
                });
            });
            
            // 使用 document 监听全局事件，确保拖动范围不受限制
            const mousemoveHandler = Pe => {
                if (he && (Pe.x >= ce.getBoundingClientRect().left && Pe.x <= ce.getBoundingClientRect().left + ce._width())) {
                    const progress = (Pe.x - ce.getBoundingClientRect().left) / ce._width();
                    window.scrollTo({
                        behavior: "instant",
                        left: 0,
                        top: u._top() - (s.plgs?.variables?.getNavHeight() || 0) + p + g * progress
                    });
                }
            };
            
            const touchmoveHandler = Pe => {
                if (!he) return;
                const Fe = Pe.changedTouches[0].clientX;
                if (Fe >= ce.getBoundingClientRect().left && Fe <= ce.getBoundingClientRect().left + ce._width()) {
                    const progress = (Fe - ce.getBoundingClientRect().left) / ce._width();
                    window.scrollTo({
                        behavior: "instant",
                        left: 0,
                        top: u._top() - (s.plgs?.variables?.getNavHeight() || 0) + p + g * progress
                    });
                }
            };
            
            const mouseupHandler = () => {
                he = false;
            };
            
            const touchendHandler = () => {
                he = false;
            };
            
            // 存储全局事件监听器引用
            globalEventListeners.mousemove = mousemoveHandler;
            globalEventListeners.touchmove = touchmoveHandler;
            globalEventListeners.mouseup = mouseupHandler;
            globalEventListeners.touchend = touchendHandler;
            
            document.addEventListener("mousemove", mousemoveHandler);
            document.addEventListener("touchmove", touchmoveHandler);
            window.addEventListener("mouseup", mouseupHandler);
            window.addEventListener("touchend", touchendHandler);
        }
    };

    // ==================== 里程碑动画初始化 ====================
    
    // 全局事件监听器管理
    const globalEventListeners = {
        mousemove: null,
        touchmove: null,
        mouseup: null,
        touchend: null
    };
    
    // 清理全局事件监听器
    function cleanupGlobalEventListeners() {
        if (globalEventListeners.mousemove) {
            document.removeEventListener('mousemove', globalEventListeners.mousemove);
            globalEventListeners.mousemove = null;
        }
        if (globalEventListeners.touchmove) {
            document.removeEventListener('touchmove', globalEventListeners.touchmove);
            globalEventListeners.touchmove = null;
        }
        if (globalEventListeners.mouseup) {
            window.removeEventListener('mouseup', globalEventListeners.mouseup);
            globalEventListeners.mouseup = null;
        }
        if (globalEventListeners.touchend) {
            window.removeEventListener('touchend', globalEventListeners.touchend);
            globalEventListeners.touchend = null;
        }
    }
    
    function initMilestoneAnimation() {
        // console.log('-------case------- 开始初始化里程碑动画');
        
        // 清理之前的事件监听器
        cleanupGlobalEventListeners();
        
        const milestoneSection = query('#section-milestone');
        if (!milestoneSection) {
            // console.log('-------case------- 未找到里程碑section元素');
            return;
        }
        
        // 创建滚动管理器
        const scrollManager = new ScrollManager();
        
        // 扩展滚动管理器以支持 addScroll 方法
        const originalAddScroll = scrollManager.addScroll.bind(scrollManager);
        scrollManager.addScroll = function(options) {
            return originalAddScroll(options);
        };
        
        // 添加 plgs 属性以兼容原代码
        scrollManager.plgs = {
            variables: {
                getNavHeight: () => 0
            }
        };
        
        // 添加设备检测方法
        scrollManager.isMo = isMo;
        scrollManager.isPad = isPad;
        scrollManager.isPc = isPc;
        scrollManager.isXl = isXl;
        
        // console.log('-------case------- 创建滚动管理器:', scrollManager);
        
        // 根据设备类型调用相应的函数
        if (isMo()) {
            // console.log('-------case------- 检测到移动端，调用hi函数');
            hi(scrollManager, milestoneSection);
        } else if (isPad()) {
            // console.log('-------case------- 检测到平板端或大屏PC端，调用ts函数');
            ts(scrollManager, milestoneSection);
        } else if (isPc()) {
            // console.log('-------case------- 检测到PC端，调用Bs函数');
            Bs(scrollManager, milestoneSection);
        }
    }

    // ==================== 线性动画 ====================
    
    function initLinearAnimation() {
        const linearElements = queryAll('[ani-linear]');
        
        linearElements.forEach(element => {
            initSingleLinearAnimation(element);
        });
    }
    
    function initSingleLinearAnimation(element) {
        const originText = element.query('.origin-text');
        const resultText = element.query('.result-text');
        
        if (!originText || !resultText) return;
        
        // 处理文本分割
        processTextNodes(originText, resultText);
        
        // 移除原始文本
        originText.remove();
        
        // 创建动画
        const chars = resultText.queryAll('.split-chars');
        // const duration = 300;
        
        chars.forEach((char, index) => {
            char.style.opacity = '0.1';
            // char.style.transition = `opacity ${duration}ms ease`;
            // char.style.transitionDelay = `${index * duration * 0.1}ms`;
        });
        
        // 滚动监听
        const linearScrollManager = new ScrollManager();
        let animated = false;
        
        linearScrollManager.addScroll({
            element: element,
            start: () => element._top() - vh(100),
            end: () => element._bottom(),
            handler: (progress) => {
                if (progress > 0 && !animated) {
                    animated = true;
                    chars.forEach(char => {
                        char.style.opacity = '1';
                    });
                } else if (progress === 0 && animated) {
                    animated = false;
                    chars.forEach(char => {
                        char.style.opacity = '0.1';
                    });
                }
            }
        });
    }
    
    function processTextNodes(originText, resultText) {
        const childNodes = Array.from(originText.childNodes);
        
        childNodes.forEach((node, index) => {
            if (node.nodeName === '#text') {
                processTextNode(node, resultText);
            } else if (node.nodeName === 'SPAN') {
                // 在span标签前添加空格（如果前面有文本节点且以空格结尾）
                if (index > 0) {
                    const prevNode = childNodes[index - 1];
                    if (prevNode.nodeName === '#text' && prevNode.textContent.trim() !== '') {
                        const space = document.createElement('span');
                        space.innerHTML = '&nbsp;';
                        resultText.appendChild(space);
                    }
                }
                processSpanNode(node, resultText);
            } else if (node.nodeName === 'BR') {
                const br = document.createElement('br');
                resultText.appendChild(br);
            }
        });
    }
    
    function processTextNode(node, resultText) {
        const text = node.textContent || '';
        const words = text.trim().split(' ');
        
        words.forEach((word, wordIndex) => {
            if (wordIndex > 0) {
                const space = document.createElement('span');
                space.innerHTML = '&nbsp;';
                resultText.appendChild(space);
            }
            
            const chars = word.split('');
            const wordDiv = document.createElement('div');
            wordDiv.classList.add('split-words');
            
            chars.forEach(char => {
                const charDiv = document.createElement('div');
                charDiv.classList.add('split-chars');
                charDiv.innerText = char;
                wordDiv.appendChild(charDiv);
            });
            
            resultText.appendChild(wordDiv);
        });
    }
    
    function processSpanNode(node, resultText) {
        const span = document.createElement('span');
        span.classList.add('gradient-span');
        
        const text = node.textContent || '';
        const words = text.trim().split(' ');
        
        words.forEach((word, wordIndex) => {
            if (wordIndex > 0) {
                const space = document.createElement('span');
                space.innerHTML = '&nbsp;';
                span.appendChild(space);
            }
            
            const chars = word.split('');
            const wordDiv = document.createElement('div');
            wordDiv.classList.add('split-words');
            
            chars.forEach(char => {
                const charDiv = document.createElement('div');
                charDiv.classList.add('split-chars');
                charDiv.innerText = char;
                wordDiv.appendChild(charDiv);
            });
            
            span.appendChild(wordDiv);
        });
        
        const spawnDiv = document.createElement('div');
        spawnDiv.classList.add('spawn-div');
        span.appendChild(spawnDiv);
        
        resultText.appendChild(span);
    }

    // ==================== 初始化 ====================
    
    function init() {
        // 等待DOM加载完成
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
            return;
        }
        
        // 初始化动画
        initMilestoneAnimation();
        initLinearAnimation();
        
        // console.log('Case.js 初始化完成');
    }
    
    // 启动应用
    init();
    
})();
